
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/sections/components/StageSideAreaBorder/StageSideAreaBorder.scss.css.virtualfile';
        module.exports = {"border":"_border_9cc9d_7","mobileEditor":"_mobileEditor_9cc9d_14","left":"_left_9cc9d_14"};